import { useEffect, useState } from "react";
import useIsMounted from "../useIsMounted";
import niuStatsSingleton from "./provider";
import { TNiuStatsData, TUseNiuStats } from "./useNiuStats.types";

const useNiuStats: TUseNiuStats = (initialData) => {
    const [data, setData] = useState<TNiuStatsData>(initialData);
    const isMounted = useIsMounted();

    useEffect(() => {
        const unsubscribe = niuStatsSingleton.subscribe((data) => {
            if (!isMounted()) {
                return;
            }
            setData(data);
        });

        return () => unsubscribe();
    }, []);

    return [data, !data];
};

export default useNiuStats;
